<div>
    <div class="col-12 mt-2 p-0">
        <p class="design-modal-title">{{ 'app.producto.informacion_de_producto.ia_limite_alcanzado' | translate }}</p>
    </div>
    <div class="mt-3">
        <p class="description">{{ 'app.global.modals.wizard-ia-modal-error-token-short' | translate }}</p>
    </div>
    <div class="d-flex justify-content-between justify-content-sm-end mt-3 mt-lg-4">
        <button class="btn btn-continue" mat-button (click)="close()" cdkFocusInitial>
            {{ 'app.ecommerce_metodos_envio.envialo_com.operadores.servicios_modal.buttons.entendido' | translate }}
        </button>
    </div>
</div>
